// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__eWH_X","link":"styles_link__S9gi2","underline":"styles_underline__I2vVg","textUnderline":"styles_textUnderline__vgDx_"};